module.exports = __webpack_public_path__ + "static/media/Nov13-17.83c2b417.png";